const LinkPreviewCard = ({ blogData }) => {
  const handlePreviewClick = () => {
    window.open(blogData.url, "_blank");
  };

  return (
    <div
      onClick={handlePreviewClick}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "1rem",
        borderRadius: "10px",
        width: "25rem",
        height: "30rem",
        paddingTop: "1.5rem",
        cursor: "pointer",
        boxShadow:
          "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          flexDirection: "column",
        }}
      >
        <div>
          <img
            style={{
              width: "100%",
              borderRadius: "5px",
              height: "15rem",
              objectFit: "cover",
            }}
            src={blogData?.imageUrl}
            alt=""
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <p
            style={{
              lineHeight: "1.5rem",
              color: "#b3c5efcc",
              objectFit: "cover",
            }}
          >
            {blogData?.title}
          </p>
          <p style={{ lineHeight: "1.5rem", color: "#ffffffa8" }}>
            {blogData?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LinkPreviewCard;
